<template>
  <f7-toolbar v-show="showTabbar" tabbar icons bottom>
    <f7-link href="/"
      icon-f7="house_fill"
      :text="$t('tabs.home')"
      tab-link
      route-tab-id="home"
    ></f7-link>
    <!--
      Poola teaser — the headline marketing surface. A STANDALONE route link
      (no route-tab-id / no matching <f7-tab>), like the notifications link.
      Placed right after Home for prominence and highlighted via .poola-tab-link
      (brand-accent tint + a small "new" dot) — it's the marketing centerpiece.
    -->
    <f7-link href="/poola/"
      icon-f7="flame_fill"
      :text="$t('tabs.poola')"
      class="poola-tab-link"
      tab-link
    ></f7-link>
    <f7-link href="/wallet/"
      icon-f7="wallet_fill"
      :text="$t('tabs.wallet')"
      tab-link
      route-tab-id="wallet"
    ></f7-link>
    <f7-link href="/orders/"
      icon-material="inventory"
      :text="$t('tabs.orders')"
      tab-link
      route-tab-id="orders"
    ></f7-link>
    <f7-link href="/profile/"
      icon-f7="person_fill"
      :text="$t('tabs.profile')"
      tab-link="#profile"
      route-tab-id="profile"
    ></f7-link>
    <!--
      Notification center tab link.
      :badge uses F7-link's native badge prop — no manual <f7-badge> wrapper.
      Pass `undefined` (not 0) when there are no unread items so F7 does
      not render an empty badge element in the DOM.
    -->
    <f7-link href="/notifications/"
      icon-f7="bell_fill"
      :text="$t('tabs.notifications')"
      :badge="unreadCount || undefined"
      badge-color="red"
      tab-link
    ></f7-link>
  </f7-toolbar>
  <f7-tabs routable>
    <f7-tab id="home"></f7-tab>
    <f7-tab id="wallet"></f7-tab>
    <f7-tab id="orders"></f7-tab>
    <f7-tab id="profile"></f7-tab>
  </f7-tabs>


</template>

<script setup>
import { storeToRefs } from 'pinia';
import { inject, ref } from 'vue';
import { useNotificationStore } from '@/stores/notificationStore.js';

defineOptions({
  name: 'TabbarNavigation',
});

// Provided by AppLayout. Default keeps the tabbar visible when this
// component is mounted in isolation (tests, future re-mounting paths).
const showTabbar = inject('showTabbar', ref(true));

const notificationStore = useNotificationStore();
const { unreadCount } = storeToRefs(notificationStore);
</script>

<style scoped>
/*
  Poola is the headline marketing surface, so its tab link stands out from the
  neutral siblings. The flame icon carries a warm "fire" gradient (amber -> orange)
  so it reads as a hot, eye-catching highlight even when inactive — the neutral
  siblings are cool gray/purple. We override F7's OWN tabbar-link color variables
  (no specificity war) so the label matches the flame, and keep the small teal
  "new" dot as a complementary pop. Logical positioning (inset-inline-end) keeps
  the dot on the correct side in RTL. Mirrored in SupplierTabbarNavigation.vue.
*/
.poola-tab-link {
  --f7-tabbar-link-inactive-color: var(--poolit-warning-600);
  --f7-tabbar-link-active-color: var(--poolit-warning-500);
}

.poola-tab-link :deep(.icon) {
  position: relative;
  overflow: visible;
  /* Fire gradient clipped to the flame glyph. */
  background: linear-gradient(160deg, #fbbf24 0%, #fb923c 55%, #f97316 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

/* Active tap: hotter glow so the highlight still reacts to selection. */
.poola-tab-link.tab-link-active :deep(.icon) {
  filter: drop-shadow(0 0 5px rgba(249, 115, 22, 0.55));
}

.poola-tab-link :deep(.icon)::after {
  content: '';
  position: absolute;
  top: -2px;
  inset-inline-end: -3px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  /* The dot is a solid mark, not part of the clipped glyph. */
  -webkit-text-fill-color: initial;
  background-color: var(--poolit-accent-main);
}
</style>
